export function stringToBoolean(str) {
  if (typeof str !== "string") return false;
  switch (str.trim().toLowerCase()) {
    case "true":
      return true;
    case "false":
      return false;
    default:
      return false;
  }
}


export const sumOfRecordCounts = (obj) => obj?.recordcounts?.reduce((acc, curr) => acc + curr, 0).toFixed(2) ?? 0;
export const sumOfRecordCountsWithoutDecimal = (obj) => obj?.recordcounts?.reduce((acc, curr) => acc + curr, 0) ?? 0;

export function secondsToHHMMSS(totalSeconds) {
  const sign = totalSeconds < 0 ? "-" : "";
  const absSeconds = Math.abs(totalSeconds);

  const hours = Math.floor(absSeconds / 3600);
  const minutes = Math.floor((absSeconds % 3600) / 60);
  const seconds = absSeconds % 60;

  return sign + [
    hours.toString().padStart(2, "0"),
    minutes.toString().padStart(2, "0"),
    seconds.toString().padStart(2, "0")
  ].join(":");
}


export function validateUnitActivityType(unit, activityType) {
  const unitActivityTypeValidationObject = [
    { unit: "LBS", activityType: "Weight Lift" },
    { unit: "KGS", activityType: "Weight Lift" },
    { unit: "KCAL", activityType: "Calories" },
    { unit: "REPS", activityType: "Reps" },
    { unit: "MINUTES", activityType: "Workout Duration" },
    { unit: "COUNT", activityType: "Workout Count" }
  ];

  return unitActivityTypeValidationObject.some(
    (item) => item.unit === unit && item.activityType === activityType
  );
}

